import { Amount } from '@root/api/ump-ewallet'

export const checkIsDenominationSoldOut = (amount: Pick<Amount, 'base' | 'fee' | 'total'> | null) =>
  !amount?.base || amount?.base === '0'
